import { styled } from '@mui/material/styles';
import { getCssPx } from 'components/ui/utilities/zoom';
import { RED } from 'theme';

export const ReallocationFailureTabBadge = styled('span')({
  alignItems: 'center',
  color: RED[600],
  display: 'inline-flex',
  fontWeight: 700,
  gap: getCssPx(2),
  marginLeft: getCssPx(6),
  verticalAlign: 'middle',
  '& svg': {
    fontSize: getCssPx(14),
  },
});
